export default "/images/76708c8217694d922609f198ab14156a.avif";